import { useContext, useState, useRef, useEffect } from 'react';
import { GlobalMobileContext } from '../../contexts/globalMobileContext';

import "./pages.css";

import { Modal } from 'bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import LightButtonComponent from '../../components/commons/LightButtonComponent'
import ClosePageButtonComponent from '../../components/commons/ClosePageButtonComponent';

import styles from './Mobile_ConferenceTopicPage.module.css'

const Mobile_ConferenceTopicPage = () => {
    const {
        mobileSocketRef, currentTopicsList, setCurrentTopicsList,
        currentConference, setCurrentError, currentUser, topicIdParam,
        typeParam, selectedEntity, setSelectedEntity,
        setTopicIdParam, setTypeParam
    } = useContext(GlobalMobileContext);

    const [expandedTopicId, setExpandedTopicId] = useState(null);

    const fileInputRef = useRef(null);

    const [filesToBeUploaded, setFilesToBeUploaded] = useState([]);

    const modalRef = useRef(null);

    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedDirectory, setSelectedDirectory] = useState(null);

    // const startX = useRef(0);
    // const startY = useRef(0);
    // const isDragging = useRef(false);
    // const draggedElement = useRef(null);

    // const [draggedFileId, setDraggedFileId] = useState(null);


    useEffect(() => {
        const modalElement = document.getElementById('addFileModal');
        if (modalElement && !modalRef.current) {
            modalRef.current = new Modal(modalElement, { backdrop: true });
        }
    }, []);

    useEffect(() => {
        if (!modalRef.current) return;

        if (!selectedEntity) {
            modalRef.current.hide();
            document.body.classList.remove('modal-open');
            document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        }
        // if (modalRef.current) {
        //     if (selectedEntity) {
        //         setTimeout(() => {
        //             modalRef.current.show();
        //         }, 1000)
        //     } else {
        //         modalRef.current.hide();
        //         document.body.classList.remove('modal-open');
        //         document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        //     }
        // }
    }, [selectedEntity]);

    useEffect(() => {
        if (!modalRef.current) return;

        if (topicIdParam) {
            if (typeParam === "topic") {
                setSelectedEntity(currentTopicsList.find(topic => topic._id === topicIdParam));
            } else if (typeParam) {
                let selectedTopic = currentTopicsList.find(topic => topic._id === typeParam);
                if (selectedTopic) {
                    setSelectedEntity(selectedTopic.subtopics.find(subtopic => subtopic._id === topicIdParam));
                }
            }

            if (modalRef.current) {
                modalRef.current.show();
            }
            
            setTopicIdParam(null);
            setTypeParam(null);
        }
    }, [topicIdParam, typeParam, currentTopicsList, modalRef]);

    const icon = (type) => {
        switch (true) {
            case type.includes("image"): return "file-image";
            case type.includes("video"): return "file-video";
            case type.includes("pdf"): return "file-pdf";
            case type.includes("word"): return "file-word";
            case type.includes("excel"): return "file-excel";
            case type.includes("site"): return "file-export";
            default: return "file-lines";
        }
    };

    const onFileChange = event => {
        if (event.target.files.length > 0) {
            let filesArray = []
            for (let i = 0; i < event.target.files.length; i++) {
                let file = event.target.files[i]

                file.newName = file.name.replace(/\.[^/.]+$/, "");
                file.previewURL = URL.createObjectURL(file);

                filesArray.push(file);
            }
            // setFilesToBeUploaded([...filesArray, ...filesToBeUploaded])

            setFilesToBeUploaded(prev => [...filesArray, ...prev]);

            if (modalRef.current) {
                modalRef.current.show();
            }
        }
    };

    const addNewFile = () => {

        if (filesToBeUploaded.length === 0) return;

        let filesInfo = []
        for (let i = 0; i < filesToBeUploaded.length; i++) {
            const element = filesToBeUploaded[i];
            filesInfo.push({ name: element.newName, type: element.type })
        }

        var data = {
            ownerId: currentUser._id,
            uploadFiles: filesToBeUploaded,
            filesInfo
        };

        let type = "Subtopic"
        if (selectedEntity.subtopics) {
            type = "Topic"
        }

        mobileSocketRef.current.emit("MOBILE_CONFERENCE_ADD_NEW_LOCAL_FILES_TO_TOPIC", {
            data,
            parentId: selectedEntity._id,
            type,
            conferenceId: currentConference._id
        }, (callback) => {
            if (!callback.error && callback.response) {
                const updatedList = currentTopicsList.map(topic => {
                    if (type === "Topic" && topic._id === selectedEntity._id) {
                        return { ...topic, files: callback.response };
                    }

                    if (type === "Subtopic") {
                        return {
                            ...topic,
                            subtopics: topic.subtopics.map(sub => {
                                if (sub._id === selectedEntity._id) {
                                    return { ...sub, files: callback.response };
                                }
                                return sub;
                            })
                        };
                    }

                    return topic;
                });

                setCurrentTopicsList(updatedList);
                setFilesToBeUploaded([]);
            } else {
                setCurrentError("Error uploading files. Try again.");
            }

            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
            setSelectedEntity(null);

        });

    }

    const handleCloseModal = (id) => {
        if (selectedEntity !== null) {
            setSelectedEntity(null);
        }
        setFilesToBeUploaded([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        if (selectedDirectory !== null) {
            setSelectedDirectory(null);
        }
        if (selectedFile !== null) {
            setSelectedFile(null);
        }

        const modalEl = document.getElementById(id);
        if (modalEl) {
            const modalInstance = Modal.getInstance(modalEl);
            if (modalInstance) {
                modalInstance.hide();
                document.body.classList.remove('modal-open');
                document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
            }
        }
    };


    const deleteExistingFile = () => {

        let type = "Subtopic"
        if (selectedDirectory.subtopics) {
            type = "Topic"
        }

        mobileSocketRef.current.emit("MOBILE_CONFERENCE_DELETE_DOCUMENT", {
            parentId: selectedDirectory._id,
            refType: type,
            conferenceFileId: selectedFile._id,
            conferenceId: currentConference._id
        }, (callback) => {
            if (!callback.error && callback.response) {
                const updatedList = currentTopicsList.map(topic => {
                    if (type === "Topic" && topic._id === selectedDirectory._id) {
                        return { ...topic, files: callback.response.files };
                    }

                    if (type === "Subtopic") {
                        return {
                            ...topic,
                            subtopics: topic.subtopics.map(sub => {
                                if (sub._id === selectedDirectory._id) {
                                    return { ...sub, files: callback.response.files };
                                }
                                return sub;
                            })
                        };
                    }

                    return topic;
                });

                setCurrentTopicsList(updatedList);

            } else {
                setCurrentError("Error deleting file. Try again.");
            }

            handleCloseModal("deleteEntityModal")
        });
    }

    const deleteNewFile = (indexToDelete) => {
        setFilesToBeUploaded(prevFiles => prevFiles.filter((_, index) => index !== indexToDelete));
    }

    const formatDate = (scheduleDateString) => {
        const scheduledDate = new Date(scheduleDateString)

        const formattedDate = scheduledDate.toLocaleDateString("en-GB", {
            weekday: "short",
            day: "2-digit",
            month: "short"
        });

        const formatStartHour = scheduledDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })

        return formattedDate + " at " + formatStartHour
    }

    const showDeleteModal = (file, directory) => {
        setSelectedFile(file)
        setSelectedDirectory(directory)

        const modalEl = document.getElementById("deleteEntityModal");
        if (modalEl) {
            const modal = new Modal(modalEl);
            modal.show();
        }
    };

    // const handlePointerDown = (e) => {
    //     startX.current = e.clientX
    //     startY.current = e.clientY;
    //     draggedElement.current = e.currentTarget;
    //     draggedElement.current.setPointerCapture(e.pointerId);

    //     draggedElement.current.style.transition = 'none';
    //     // draggedElement.current.style.position = 'fixed';

    //     e.currentTarget.setPointerCapture(e.pointerId);
    // };

    // const handlePointerMove = (e) => {
    //     if (!draggedElement.current) return;

    //     const deltaX = e.clientX - startX.current;
    //     const deltaY = e.clientY - startY.current;

    //     if (!isDragging.current && Math.abs(deltaX) > Math.abs(deltaY) && deltaX < 0) {
    //         isDragging.current = true;
    //         setDraggedFileId(draggedElement.current.id)
    //     }

    //     if (isDragging.current) {
    //         e.preventDefault();
    //         if (deltaX > 0) {
    //             draggedElement.current.style.transform = `translateX(0px)`;
    //         } else if (deltaX < -100) {
    //             draggedElement.current.style.transform = `translateX(-60px)`;
    //         } else {
    //             draggedElement.current.style.transform = `translateX(${deltaX}px)`;
    //         }

    //     }
    // };

    // const handlePointerUp = (e, file, directory) => {
    //     if (!draggedElement.current) return;

    //     const deltaX = e.clientX - startX.current;

    //     // draggedElement.current.style.position = 'relative';

    //     draggedElement.current.releasePointerCapture(e.pointerId);

    //     if (isDragging.current) {
    //         if (deltaX < -30) {
    //             setSelectedFile(file)
    //             setSelectedDirectory(directory)
    //         } else {
    //             draggedElement.current.style.transition = 'transform 0.2s ease-out';
    //             draggedElement.current.style.transform = 'translateX(0)';
    //             setTimeout(() => {
    //                 if (draggedElement.current) {
    //                     draggedElement.current.style.transition = '';
    //                 }
    //             }, 200);
    //         }
    //     }

    //     isDragging.current = false;
    //     draggedElement.current = null;
    //     setDraggedFileId(null);
    // };


    return (
        <>
            <div className={styles.pagetitle}>
                <h1 className={styles.title}>Files</h1>
                <h1 className={styles.bigTitleName}>{currentConference.name}</h1>
            </div>

            <section className={styles.sectionScroll} >
                <div className={styles.row} >
                    <div>

                        {currentTopicsList && currentTopicsList.map((entity, index) => (<div className={styles.cardTopic} key={entity._id}>
                            <div className={styles.cardTopicBody}>
                                <div style={{ fontSize: 16, lineHeight: "20px" }}>{index < 9 ? `0${index + 1}` : index + 1}.</div>
                                <div>{entity.name}</div>
                                <div className={styles.fileList}>
                                    {entity.files.map((file) => (<div className={styles.fileZone} key={file._id}>
                                        {/* <div className={styles.removeSign} style={{ backgroundColor: draggedFileId === file._id ? "#FF5D40" : "transparent" }}>
                                            <FontAwesomeIcon className={styles.iconTrash} icon={byPrefixAndName.fal["trash"]} />
                                        </div> */}
                                        <div className={styles.fileCard} id={file._id} style={{ position: 'absolute', top: 0, left: 0 }}>
                                            <div style={{ width: "28px" }}><FontAwesomeIcon className={styles.iconFiles} icon={byPrefixAndName.fas[icon(file.docsFile.type)]} /></div>
                                            <div className={styles.fileDetails}>
                                                {file.docsFile.name}
                                                <div className={styles.descriptionFile}>
                                                    Uploaded:
                                                    <div className={styles.dateFile}>{file.createdAt ? formatDate(file.createdAt) : "Mon 12 Apr. at 16:00"}</div>
                                                </div>
                                            </div>
                                            <FontAwesomeIcon className="icon-more" icon={byPrefixAndName.fal["trash"]} onClick={(e) => {
                                                e.stopPropagation()
                                                showDeleteModal(file, entity)
                                            }} />
                                        </div>
                                    </div>))}
                                </div>
                                <div className={styles.addFile} onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedEntity(entity);
                                    fileInputRef.current?.click()
                                }}>
                                    <FontAwesomeIcon className={styles.iconAdd} icon={byPrefixAndName.fal["plus"]} />
                                    Add File
                                </div>
                                {entity.subtopics.length > 0 && <div className={styles.horizontalLine} />}
                                {entity.subtopics.length > 0 && <div className={styles.subtopicCard} onClick={() => setExpandedTopicId(prev => prev === entity._id ? null : entity._id)}>
                                    <div className={styles.subtopicDropdown}>
                                        Subtopics [{entity.subtopics.length}]
                                        <FontAwesomeIcon className={styles.iconDown} icon={byPrefixAndName.fal[expandedTopicId === entity._id ? "chevron-up" : "chevron-down"]} />
                                    </div>
                                </div>}
                                {expandedTopicId === entity._id && entity.subtopics.map((subtopic, index) => (<div className={styles.subtopicCard} key={subtopic._id} >
                                    <div>{subtopic.name}</div>
                                    <div className={styles.fileList} style={{ marginTop: subtopic.files.length === 0 ? 0: "" }}>
                                        {subtopic.files.map((file) => (<div className={styles.fileCard} key={file._id} >
                                            <FontAwesomeIcon className={styles.iconFiles} icon={byPrefixAndName.fas[icon(file.docsFile.type)]} />
                                            <div className={styles.fileDetails}>
                                                {file.docsFile.name}
                                                <div className={styles.descriptionFile}>
                                                    Uploaded:
                                                    <div className={styles.dateFile}>{file.createdAt ? formatDate(file.createdAt) : "Mon 5 Apr. at 15:00"}</div>
                                                </div>
                                            </div>
                                            <FontAwesomeIcon className="icon-more" icon={byPrefixAndName.fal["trash"]} onClick={(e) => {
                                                e.stopPropagation()
                                                showDeleteModal(file, subtopic)
                                            }} />
                                        </div>))}

                                    </div>
                                    <div className={styles.addFile} onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedEntity(subtopic)
                                        fileInputRef.current?.click()
                                    }}>
                                        <FontAwesomeIcon className={styles.iconAdd} icon={byPrefixAndName.fal["plus"]} />
                                        Add File
                                    </div>
                                    {entity.subtopics.length - 1 > index && <div className={styles.horizontalLine} />}
                                </div>))}
                            </div>
                        </div>))}

                    </div>
                </div>
                <div className={styles.topShadow} />
                <div className={styles.bottomShadow} />

            </section>

            <div className="modal fade" id="addFileModal" tabIndex="-2">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ backgroundColor: "#292148", color: "#FFFFFF" }}>
                        <div className="modal-header" style={{ borderColor: "transparent", justifyContent: "center", textAlign: "center", paddingBottom: 0 }}>
                            <h5 className="modal-title" style={{ maxWidth: "80%" }}>Add Files to {selectedEntity?.name}</h5>
                            <ClosePageButtonComponent setClose={() => handleCloseModal("addFileModal")} style={{ top: "20px", right: "20px", fontSize: "20px", lineHeight: "10px" }} />
                        </div>
                        <div className="modal-body">
                            <div className="mb-3" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                <input
                                    ref={fileInputRef}
                                    className="form-control"
                                    type="file"
                                    id="fileUpload"
                                    onChange={onFileChange}
                                    multiple
                                    style={{ display: 'none' }}
                                />
                                <div className='add-files-button' onClick={() => fileInputRef.current?.click()}>
                                    <FontAwesomeIcon icon={byPrefixAndName.fal["add"]} />
                                </div>
                                <LightButtonComponent
                                    style={{
                                        width: "auto", paddingLeft: "10px", paddingRight: "10px", height: "38px", fontSize: "18px", lineHeight: "20px", borderRadius: "4px", alignItems: "center", opacity: filesToBeUploaded.length > 0 ? 1 : 0
                                    }}
                                    onClick={addNewFile}>
                                    Upload
                                </LightButtonComponent>
                            </div>
                            {filesToBeUploaded.length > 0 && (
                                <ul className="list-group mb-3" style={{ gap: "5px" }}>
                                    {filesToBeUploaded.map((file, index) => (
                                        <li className="list-group-item d-flex justify-content-between align-items-center" key={index}
                                            style={{ backgroundColor: "#FFFFFF0D", borderColor: "transparent", color: "#FFFFFFCC", borderRadius: "5px", position: 'relative' }}>
                                            <input type="text" className="form-control me-2 form-control-custom " value={file.newName}
                                                onChange={(e) => {
                                                    const updatedFiles = [...filesToBeUploaded];
                                                    updatedFiles[index].newName = e.target.value;
                                                    setFilesToBeUploaded(updatedFiles);
                                                }}
                                                onFocus={(e) => {
                                                    e.currentTarget.parentElement.style.border = "1px solid #33FFC8"
                                                    e.currentTarget.parentElement.children[1].style.backgroundColor = "#33FFC8"
                                                    e.currentTarget.parentElement.children[1].style.color = "black"
                                                }}
                                                onBlur={(e) => {
                                                    e.currentTarget.parentElement.style.border = "none"
                                                    e.currentTarget.parentElement.children[1].style.backgroundColor = "transparent"
                                                    e.currentTarget.parentElement.children[1].style.color = "white"


                                                }}
                                            />
                                            <div style={{
                                                position: 'relative', display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: "center",
                                                borderRadius: "5px", padding: "8px", position: "absolute", right: "5px"
                                            }}>
                                                <FontAwesomeIcon onClick={() => deleteNewFile(index)} icon={byPrefixAndName.fal["trash"]} />
                                            </div>

                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteEntityModal" tabIndex="-2">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ backgroundColor: "#292148", color: "#FFFFFF" }}>
                        <div className="modal-header" style={{ borderColor: "#FFFFFF4D" }}>
                            <h5 className="modal-title">Delete {selectedFile?.docsFile.name}</h5>
                            <ClosePageButtonComponent setClose={() => handleCloseModal("deleteEntityModal")} style={{ top: "20px", right: "20px", fontSize: "20px", lineHeight: "10px" }} />
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete the file?
                        </div>
                        <div className="modal-footer" style={{ borderColor: "#FFFFFF4D" }}>
                            <LightButtonComponent
                                style={{ width: "auto", height: "38px", fontSize: "18px", lineHeight: "20px", borderRadius: "4px", marginTop: "5px", alignItems: "center" }}
                                onClick={deleteExistingFile}>
                                Delete
                            </LightButtonComponent>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Mobile_ConferenceTopicPage;
